import React from "react";
import { FaGooglePlay } from "react-icons/fa";

import "./AppDownloadBanner.css";

const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.filingstack.business";

export default function AppDownloadBanner({ variant = "dashboard" }) {
  return (
    <aside
      className={`app-download-banner app-download-banner--${variant}`}
      aria-label="FilingStack Business mobile app announcement"
    >
      <div className="app-download-banner__icon" aria-hidden="true">
        📱
      </div>
      <div className="app-download-banner__copy">
        <div className="app-download-banner__eyebrow">NOW AVAILABLE</div>
        <strong>Take FilingStack Business with you</strong>
        <span>
          Manage your business on the go with our new Android app.
        </span>
      </div>
      <a
        className="app-download-banner__button"
        href={GOOGLE_PLAY_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Download FilingStack Business on Google Play (opens in a new tab)"
      >
        <FaGooglePlay aria-hidden="true" />
        <span>
          <small>GET IT ON</small>
          Google Play
        </span>
      </a>
    </aside>
  );
}
